import React from 'react'
import { Dropdown, Menu } from 'antd'
import ArrowIcon from '../icons/ArrowIcon'
import { FilterState } from '../../types'

type MoreFilterSelectorProps = {
  filter: FilterState
  filterCount: number
  webWatermarkSwitch: boolean
  onOpenLocationModal: () => void
  onChangeFilter: (override: Partial<FilterState>) => void
  getPopupContainer: () => HTMLElement
  onSensorOfClickEvent: (
    clickItem: string,
    restProperties?: Record<string, any>
  ) => void
}

const { SubMenu } = Menu

const getExistWatermarkText = (existWatermark = 0) => {
  if (existWatermark === 1) return '含水印'
  if (existWatermark === 2) return '无水印'
  return '不限'
}

/**
 * 条件筛选下拉：包含「筛选地点 / 内容类型 / 含水印」三项
 * 注：「照片标签」已拆分为独立的 TagFilterSelector pill
 */
const MoreFilterSelector: React.FC<MoreFilterSelectorProps> = ({
  filter,
  filterCount,
  webWatermarkSwitch,
  onOpenLocationModal,
  onChangeFilter,
  getPopupContainer,
  onSensorOfClickEvent
}) => {
  const filterMoreMenu = (
    <Menu>
      <Menu.Item onClick={onOpenLocationModal}>
        <span>
          筛选地点：
          {filter.locations && filter.locations.length > 0 ? '已选择' : '不限'}
        </span>
      </Menu.Item>
      <SubMenu
        title={
          <span>
            {`内容类型：${
              filter.mediaType === null
                ? '全部'
                : filter.mediaType === 0
                  ? '仅照片'
                  : '仅视频'
            }`}
          </span>
        }
      >
        <Menu.Item
          onClick={() => {
            onChangeFilter({ mediaType: null })
            onSensorOfClickEvent('chooseFileType')
          }}
        >
          全部类型
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            onChangeFilter({ mediaType: 0 })
            onSensorOfClickEvent('chooseFileType')
          }}
        >
          照片
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            onChangeFilter({ mediaType: 1 })
            onSensorOfClickEvent('chooseFileType')
          }}
        >
          视频
        </Menu.Item>
      </SubMenu>
      {webWatermarkSwitch && (
        <SubMenu
          title={
            <span>{`含水印：${getExistWatermarkText(
              filter.existWatermark
            )}`}</span>
          }
        >
          <Menu.Item
            onClick={() => {
              onChangeFilter({ existWatermark: 0 })
              onSensorOfClickEvent('筛选水印', {
                string5: '不限'
              })
            }}
          >
            不限
          </Menu.Item>
          <Menu.Item
            onClick={() => {
              onChangeFilter({ existWatermark: 1 })
              onSensorOfClickEvent('筛选水印', {
                string5: '含水印'
              })
            }}
          >
            含水印
          </Menu.Item>
          <Menu.Item
            onClick={() => {
              onChangeFilter({ existWatermark: 2 })
              onSensorOfClickEvent('筛选水印', {
                string5: '无水印'
              })
            }}
          >
            无水印
          </Menu.Item>
        </SubMenu>
      )}
    </Menu>
  )

  return (
    <Dropdown
      popupRender={() => filterMoreMenu}
      classNames={{ root: 'filter-more-menu' }}
      getPopupContainer={getPopupContainer}
    >
      <div
        className={`pfv2-selector pfv2-selector--more ${
          filterCount > 0 ? 'pfv2-selector--active' : ''
        }`}
      >
        <div
          className={`pfv2-selector-value pfv2-selector-value--more ${
            filterCount > 0 ? 'pfv2-selector-value--active' : ''
          }`}
        >
          条件筛选
          {filterCount > 0 && `(${filterCount})`}
        </div>
        <ArrowIcon isActive={filterCount > 0} />
      </div>
    </Dropdown>
  )
}

export default MoreFilterSelector
